import { useState } from 'react';
import { t } from '../i18n';

const C = { bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56', danger: '#A32D2D', warn: '#C0392B' };

// Rule-based checks — XpertCreation ke seekhe hue Pi payment patterns.
function analyze(code) {
  const issues = [];
  const good = [];
  const c = code;
  const low = c.toLowerCase();

  const has = (re) => re.test(c);

  // 1. await in onReadyForServerApproval (galat — fire-and-forget hona chahiye)
  const approvalMatch = c.match(/onReadyForServerApproval\s*:?\s*(?:function)?\s*\(([^)]*)\)\s*(?:=>)?\s*\{([\s\S]*?)\}/);
  if (approvalMatch && /await/.test(approvalMatch[2])) {
    issues.push({ level: 'error', title: 'await inside onReadyForServerApproval',
      why: 'onReadyForServerApproval ko fire-and-forget hona chahiye. Yahan await lagane se payment flow block ho jata hai aur "pending" state phans jati hai.',
      fix: 'onReadyForServerApproval ke andar server ko approve call bhejein bina await ke: fetch("/approve", ...) — result ka intezar mat karein. Business logic onReadyForServerCompletion mein rakhein.' });
  }

  // 2. onReadyForServerCompletion missing
  if (has(/createPayment/) && !has(/onReadyForServerCompletion/)) {
    issues.push({ level: 'error', title: 'onReadyForServerCompletion missing',
      why: 'Payment complete hone par server ko batane wala callback nahi hai. Is se payment "pending" reh jati hai aur user ko cheez nahi milti.',
      fix: 'createPayment ke callbacks mein onReadyForServerCompletion (paymentId, txid) => {...} add karein — yahan server ko /complete call karein aur business logic (cheez dena) chalayein.' });
  } else if (has(/onReadyForServerCompletion/)) {
    good.push('onReadyForServerCompletion handle ho raha hai');
  }

  // 3. onIncompletePaymentFound missing
  if (has(/createPayment/) && !has(/onIncompletePaymentFound/)) {
    issues.push({ level: 'error', title: 'onIncompletePaymentFound missing',
      why: 'Adhoori (pending) purani payments handle nahi ho rahin. Yehi sab se aam wajah hai "payment pending" message ki — purani incomplete payment atki rehti hai.',
      fix: 'authenticate aur createPayment mein onIncompletePaymentFound (payment) => {...} pass karein. Us mein payment.transaction.txid check kar ke server ko /complete bhejein taake purani payment clear ho.' });
  } else if (has(/onIncompletePaymentFound/)) {
    good.push('onIncompletePaymentFound handle ho raha hai (pending payments clear hongi)');
  }

  // 4. alert() before authenticate
  const authIdx = c.search(/Pi\.authenticate/);
  const alertIdx = c.search(/alert\s*\(/);
  if (authIdx > -1 && alertIdx > -1 && alertIdx < authIdx) {
    issues.push({ level: 'warn', title: 'alert() before Pi.authenticate',
      why: 'authenticate se pehle alert() Pi Browser mein flow ko rok sakta hai.',
      fix: 'alert()/dialog authenticate ke baad chalayein, pehle nahi.' });
  }

  // 5. bare catch/except that activates anyway
  if (has(/catch\s*\([^)]*\)\s*\{\s*\}/) || has(/catch\s*\([^)]*\)\s*\{[^}]*success[^}]*\}/i)) {
    issues.push({ level: 'error', title: 'Empty or unsafe catch block',
      why: 'Payment verify fail hone par bhi catch block chup-chaap aage barh raha hai — is se bina confirm payment ke cheez activate ho sakti hai (paise ka nuqsan).',
      fix: 'catch mein error ko handle karein aur activation MAT karein. Server par payment verify fail = 400 return karein, aur frontend us par cheez na de.' });
  }

  // 6. txid verify server-side hint
  if (has(/onReadyForServerCompletion/) && !has(/txid/)) {
    issues.push({ level: 'warn', title: 'txid server ko nahi bhej rahe?',
      why: 'onReadyForServerCompletion mein txid milta hai jise server par verify karna zaroori hai.',
      fix: 'onReadyForServerCompletion (paymentId, txid) => fetch("/complete", { body: { paymentId, txid } }) — server par txid Pi API se verify karein.' });
  } else if (has(/txid/)) {
    good.push('txid use ho raha hai (server verification ke liye)');
  }

  // 7. authenticate scopes
  if (has(/Pi\.authenticate/) && !has(/payments/)) {
    issues.push({ level: 'warn', title: "'payments' scope missing in authenticate",
      why: 'Payment karne ke liye authenticate mein "payments" scope zaroori hai.',
      fix: "Pi.authenticate(['username', 'payments'], onIncompletePaymentFound) — 'payments' scope add karein." });
  }

  // good: correct order
  if (has(/Pi\.authenticate/) && has(/createPayment/)) {
    good.push('authenticate + createPayment dono maujood hain');
  }

  return { issues, good };
}

export default function PiPaymentDebugger() {
  const [code, setCode] = useState('');
  const [result, setResult] = useState(null);

  const check = () => setResult(analyze(code));

  const colorFor = (lvl) => lvl === 'error' ? C.danger : lvl === 'warn' ? C.warn : C.primary;

  return (
    <div style={{ maxWidth: 780, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>🔧 {t('pd_title')}</h1>
      <p style={{ fontSize: 13, color: C.muted, margin: '0 0 16px' }}>{t('pd_sub')}</p>

      <textarea value={code} onChange={(e) => setCode(e.target.value)} placeholder={t('pd_paste')}
        spellCheck={false}
        style={{ width: '100%', minHeight: 240, padding: 12, fontSize: 12.5, fontFamily: 'monospace', border: `0.5px solid ${C.border}`, borderRadius: 10, boxSizing: 'border-box', lineHeight: 1.5 }} />

      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button onClick={check} disabled={!code.trim()} style={{ padding: '9px 18px', fontSize: 14, fontWeight: 700, border: 'none', borderRadius: 8, background: code.trim() ? C.primary : '#ccc', color: '#fff', cursor: code.trim() ? 'pointer' : 'default' }}>{t('pd_check')}</button>
        <button onClick={() => { setCode(''); setResult(null); }} style={{ padding: '9px 18px', fontSize: 14, fontWeight: 600, border: `0.5px solid ${C.border}`, borderRadius: 8, background: '#fff', color: C.text, cursor: 'pointer' }}>{t('pd_clear')}</button>
      </div>

      {result && (
        <div style={{ marginTop: 20 }}>
          {result.issues.length === 0 && (
            <div style={{ background: '#E1F5EE', borderRadius: 10, padding: '1rem', fontSize: 14, color: C.primary }}>✅ {t('pd_no_issues')}</div>
          )}
          {result.issues.length > 0 && (
            <p style={{ fontSize: 14, fontWeight: 700, margin: '0 0 10px' }}>⚠️ {result.issues.length} {t('pd_issues_found')}</p>
          )}
          {result.issues.map((iss, i) => (
            <div key={i} style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderLeft: `4px solid ${colorFor(iss.level)}`, borderRadius: 8, padding: '0.9rem 1rem', marginBottom: 10 }}>
              <p style={{ fontSize: 14, fontWeight: 700, margin: '0 0 4px', color: colorFor(iss.level) }}>{iss.level === 'error' ? '🛑' : '⚠️'} {iss.title}</p>
              <p style={{ fontSize: 13, color: C.text, margin: '0 0 6px', lineHeight: 1.5 }}>{iss.why}</p>
              <p style={{ fontSize: 13, color: C.primary, margin: 0, lineHeight: 1.5 }}><b>✔ Fix:</b> {iss.fix}</p>
            </div>
          ))}
          {result.good.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: C.primary, margin: '0 0 6px' }}>✅ {t('pd_good')}</p>
              {result.good.map((g, i) => <p key={i} style={{ fontSize: 12.5, color: C.muted, margin: '2px 0' }}>• {g}</p>)}
            </div>
          )}
          <p style={{ fontSize: 11, color: C.muted, marginTop: 14, fontStyle: 'italic' }}>{t('pd_disclaimer')}</p>
        </div>
      )}
    </div>
  );
}
